class Router {
    routesCallbacks = new Map;

    anyCallbacks = new Set

    any(callback) {
        this.anyCallbacks.add( callback );
    }

    when(url, callback) {
        this.routesCallbacks.set( url, callback );
    }

    handle(url) {
        url = url || window.location.pathname;

        this.anyCallbacks.forEach( callback => callback( url ) );

        this.routesCallbacks.forEach( (callback, callbackUrl) => {
            if ( url.match( callbackUrl.replace('*', '(.+)') ) ) {
                callback( url );
            }
        } );
    }
}

const router = new Router;

export default router;

export {
    router
}